import { REDDIT_ACCESS_TOKEN, REDDIT_PIXEL_ID } from '../environment';

import fetch from 'node-fetch';

export type RedditConversionEvent = {
  click_id?: string;
  event_at: string;
  event_at_ms?: number;
  event_type: {
    tracking_type: 'Purchase' | 'Lead' | 'SignUp' | 'PageVisit' | string;
    custom_event_name?: string;
  };
  event_metadata?: {
    item_count?: number;
    currency?: string;
    value?: number;
    value_decimal?: number;
    conversion_id?: string;
    products?: {
      id: string;
      name?: string;
      category?: string;
    }[];
  };
  user: {
    email?: string;
    phone_number?: string;
    external_id?: string;
    uuid?: string;
    ip_address?: string;
    user_agent?: string;
    idfa?: string;
    aaid?: string;
    opt_out?: boolean;
    screen_dimensions?: {
      width: number;
      height: number;
    };
    data_processing_options?: {
      modes: string[];
      country?: string;
      region?: string;
    };
  };
};

export const sendRedditConversion = async (
  event: RedditConversionEvent,
  testMode = false,
) => {
  const payload = {
    events: [event],
    test_mode: testMode,
  };

  try {
    const endpoint = `https://ads-api.reddit.com/api/v2.0/conversions/events/${REDDIT_PIXEL_ID}`;

    const res = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${REDDIT_ACCESS_TOKEN}`,
        'Content-Type': 'application/json',
        'User-Agent': 'web:rockefeller-capi:v1.0.0 (by /u/rockefellerbot)',
      },
      body: JSON.stringify(payload),
    });

    if (!res.ok) {
      const errorBody = await res.text();
      console.error('Reddit tracking payload', payload);
      console.error(
        `Reddit CAPI failed: ${res.status} ${res.statusText} — ${errorBody}`,
      );
      return;
    }

    const json = await res.json();
    console.log('Reddit CAPI success:', json);
  } catch (error) {
    console.error('Reddit tracking payload', payload);
    console.error('Error sending Reddit conversion:', error);
  }
};

const RDT_CID_KEY = 'reddit_click_id';

export const captureRedditClickId = () => {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const cidFromUrl = urlParams.get('rdt_cid');

    if (cidFromUrl && /^[0-9]{10,30}$/.test(cidFromUrl)) {
      localStorage.setItem(RDT_CID_KEY, cidFromUrl);
      console.log('[Reddit] Captured rdt_cid:', cidFromUrl);
    }
  } catch (err) {
    console.warn('[Reddit] Failed to capture rdt_cid:', err);
  }
};

export const getRedditClickId = (): string | undefined => {
  try {
    const cid = localStorage.getItem(RDT_CID_KEY);
    return cid && /^[0-9]{10,30}$/.test(cid) ? cid : undefined;
  } catch {
    return undefined;
  }
};
